export const UserInviteSceneTranslation = {
  fi: {
    UserInviteScene: {
      title: 'Kutsu uusi admin',
    },
  },
};
